import type { ReactNode } from 'react';
import Header from './components/Header';
import { CookiesProvider } from 'react-cookie';

export default function Layout({ children }: { children: ReactNode }) {
    return (
        <CookiesProvider>
            <section className='w-full'>
                <Header />
            </section>
            {children}
        </CookiesProvider>
    );
}
